<template>
  <div :id="id" v-if="currentAnnotation === id" class="annotation position-absolute">
    <b-row>
      <b-col md="8">
        <h1>Model Predictive Control</h1>
        <slot></slot>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  methods: {
    close () {
      this.$store.commit('shouldClose', true)
    }
  },
  props: {
    currentAnnotation: {
      type: String,
      default: null
    },
    id: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
.annotation {
  width: 80%;
}
</style>
